import { render, staticRenderFns } from "./CommentsList.vue?vue&type=template&id=5de77ee8&lang=pug&"
import script from "./CommentsList.vue?vue&type=script&lang=ts&"
export * from "./CommentsList.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports